import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconPlay from 'components/icons/IconPlay';
import IconPlus from 'components/icons/iconPlus';
import useVideoMetadata from 'hooks/useVideoMetadata';
import useIsVideoPosterPlayable from 'hooks/useIsVideoPosterPlayable';
import { GALLERY_INTERACTION } from 'data-hooks/useEvents/pdpGalleryEventConstants';
import PDPGalleryRevampLifestyleThumb from '../PDPDesktopGalleryRevamp/PDPGalleryRevampLifestyleThumb';
const THUMB_CLASS = 'h-[42px] w-14 shrink-0';
// The imgix helper's 44x38 default renders blurry in these larger tiles
const THUMB_IMG_SIZE = {
  width: 56,
  height: 42
};

// Horizontal strip: video, lifestyle photos, "+" to expand
const PDPMobileGalleryRevampThumbRail = t0 => {
  const $ = _c(30);
  const {
    introVideoId,
    isVideoSelected: t1,
    onExpand,
    onSelectVideo,
    photos: t2,
    trackGalleryInteracted
  } = t0;
  const isVideoSelected = t1 === undefined ? false : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const photos = t3;
  let t4;
  if ($[2] !== introVideoId) {
    t4 = {
      videoId: introVideoId
    };
    $[2] = introVideoId;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    thumbnail: videoThumbnailUrl,
    videoUrl: videoPosterUrl
  } = useVideoMetadata(t4);
  const isPosterPlayable = useIsVideoPosterPlayable(videoPosterUrl);
  if (!photos.length) {
    return null;
  }
  const showVideoTile = !!introVideoId && (!!videoThumbnailUrl || isPosterPlayable);
  let t5;
  if ($[4] !== isVideoSelected || $[5] !== onSelectVideo || $[6] !== showVideoTile || $[7] !== videoPosterUrl || $[8] !== videoThumbnailUrl) {
    t5 = showVideoTile && <PDPGalleryRevampLifestyleThumb ariaLabel="Play product video" className={THUMB_CLASS} imgSize={THUMB_IMG_SIZE} src={videoThumbnailUrl} videoUrl={videoPosterUrl} isSelected={isVideoSelected} onClick={onSelectVideo} icon={<IconPlay width={20} height={20} />} />;
    $[4] = isVideoSelected;
    $[5] = onSelectVideo;
    $[6] = showVideoTile;
    $[7] = videoPosterUrl;
    $[8] = videoThumbnailUrl;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onExpand || $[11] !== photos || $[12] !== trackGalleryInteracted) {
    let t7;
    if ($[14] !== onExpand || $[15] !== trackGalleryInteracted) {
      t7 = (t8, index) => {
        const {
          id,
          src
        } = t8;
        return <PDPGalleryRevampLifestyleThumb key={`PDPMobileGalleryRevampRailThumb${id}`} className={THUMB_CLASS} imgSize={THUMB_IMG_SIZE} src={src} onClick={() => {
          onExpand(index);
          trackGalleryInteracted?.(GALLERY_INTERACTION.LIFESTYLE_GALLERY_OPENED);
        }} />;
      };
      $[14] = onExpand;
      $[15] = trackGalleryInteracted;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    t6 = photos.map(t7);
    $[10] = onExpand;
    $[11] = photos;
    $[12] = trackGalleryInteracted;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className="flex gap-1.5 min-w-0 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">{t5}{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const t8 = `Show all ${photos.length} photos`;
  let t9;
  if ($[20] !== onExpand || $[21] !== trackGalleryInteracted) {
    t9 = () => {
      onExpand(0);
      trackGalleryInteracted?.(GALLERY_INTERACTION.LIFESTYLE_GALLERY_OPENED);
    };
    $[20] = onExpand;
    $[21] = trackGalleryInteracted;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <IconPlus width={14} height={14} />;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t8 || $[25] !== t9) {
    t11 = <PDPGalleryRevampLifestyleThumb ariaLabel={t8} className={THUMB_CLASS} borderClass="border-gray-light5" onClick={t9}>{t10}</PDPGalleryRevampLifestyleThumb>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t7) {
    t12 = <div className="flex gap-1.5" data-xc="PDPMobileGalleryRevampThumbRail">{t7}{t11}</div>;
    $[27] = t11;
    $[28] = t7;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
};
PDPMobileGalleryRevampThumbRail.propTypes = {
  introVideoId: PropTypes.string,
  isVideoSelected: PropTypes.bool,
  onExpand: PropTypes.func,
  onSelectVideo: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string.isRequired
  })),
  trackGalleryInteracted: PropTypes.func
};
export default PDPMobileGalleryRevampThumbRail;